import { render, staticRenderFns } from "./AddWorker.vue?vue&type=template&id=3020f242&"
import script from "./AddWorker.vue?vue&type=script&lang=js&"
export * from "./AddWorker.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports